import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import OsmPoiService from "../services/OsmPoiService";

const useOsmPoiService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new OsmPoiService(client);
  }, [client]);

  return service;
};

export default useOsmPoiService;
